<!--
 * @Description: 投放线索(谷仓市场/云途市场)
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-04-19 14:44:37
 * @LastEditors: cxh
-->
<template>
    <a-button @click="showModal" :type="isLink?'link':'ghost'">
      <slot></slot>
    </a-button>
    <cos-modal
      v-model:visible="visible"
      title="投放"
      class="cluePush"
      width="670px"
      @ok="handleSubmit"
      :confirmLoading="loading"
    >
      <a-form :model="form" ref="formRef" v-if="visible" class="launchTable">
        <a-form-item name="clueIdList" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
          <a-select v-model:value="form.clueIdList" mode="multiple" :disabled="true" placeholder="请选择">
            <a-select-option v-for="item in data" :key="item.clueId" :value="item.clueId">{{
              item.customerName
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="receiver" label="投放到" :rules="[{ required: true, message: '请选择' }]">
          <a-select v-model:value="form.receiver" placeholder="请选择" :options="acceptClueSystem" @change="targetChange"/>
        </a-form-item>
        <a-form-item
          name="customerRegion"
          v-if="form.receiver !== 'cos_lbu'"
          label="客户区域"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <CustomerAreaCascader appId="cos_fbu" deptInfoId="815717" v-model:value="form.customerRegion" placeholder="请选择客户区域" @change="regionChange"/>
        </a-form-item>
        <a-form-item
          name="conductor"
          :rules="{
            required: true,
            message: '请选择'
          }"
          label="对接人"
        >
          <BatchUserList v-model:value="form.conductor" />
        </a-form-item>
        <a-form-item name="follower" label="客户负责人">
          <BatchUserList v-model:value="form.follower" @change="principalChange"/>
        </a-form-item>
      </a-form>
    </cos-modal>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cluePush } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import BatchUserList from '../BatchUserList/index.vue'
import { shareInfo } from '@dc-platform/dc-interaction'
import { bool } from 'vue-types'
const props = defineProps({
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  // 这个属性用来控制该组件是带边框的button或者链接形式文字
  isLink: {
    type: bool,
    default: false
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
})
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
// 选择负责人后保存他的区域，便于手动修改区域后，和该负责人区域不一样的话就清空负责人
const principalRegion = ref<string>()
const form = ref<any>({})
const emit = defineEmits(['success'])
const loginUser = shareInfo.getUserInfo() || {}
const acceptClueSystem = computed(() => {
  if (props.appId === 'cos_fbu') {
    return [
      {
        value: 'cos_fbu',
        label: '谷仓'
      },
      {
        value: 'cos_ofbu',
        label: '谷仓海外'
      }
    ]
  }
  return [
    {
      value: 'cos_lbu',
      label: '云途'
    }
  ]
})
const regionChange = (region: any) => {
  if (props.appId === 'cos_fbu' && region && region.custom && region.custom !== principalRegion.value) {
    form.value.follower = undefined
  }
}
const targetChange = (target: any) => {
  if (props.appId === 'cos_fbu' && target) {
    form.value.subdomain = target
  }
}
const principalChange = (user: any) => {
  if (props.appId === 'cos_fbu' && user) {
    principalRegion.value = user.deptId
    form.value.customerRegion = user.deptId
  }
}
// 保存人员信息到本地
const savePeopleMessage = () => {
  const { conductor, follower, customerRegion } = form.value
  let init = {}
  if (!loginUser.work_code) {
    return
  }
  const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
  if (leadManagePeople) {
    init = JSON.parse(leadManagePeople)
  }
  if (!init[loginUser.work_code]) {
    init[loginUser.work_code] = {}
  }
  init[loginUser.work_code][props.appId] = {
    conductor,
    follower,
    customerRegion
  }
  localStorage.setItem('dc-cos-lbu-leadManage', JSON.stringify(init))
}

// 获取上次选择人员
const initPeopleMessage = async () => {
  try {
    const init = {
      cos_lbu: {
        conductor: 'zt20309' // 李科燕
      },
      cos_fbu: {
        conductor: 'zt18054' // 覃恒梅
      }
    }
    const firstClue = props.data[0] as ClueManage
    const expectPushInfo = firstClue.expectPushInfo
    if (expectPushInfo && expectPushInfo.length) {
      // 其实只有一条
      expectPushInfo.forEach((e: any, i: number) => {
        form.value = {
          ...form.value,
          receiver: e.acceptor ? e.acceptor : props.appId,
          subdomain: e.acceptor ? e.acceptor : props.appId,
          conductor: firstClue.createBy,
          conductorName: firstClue.createByName,
          customerRegion: e.region,
          follower: e.follower,
          followerName: e.followerName
        }
      })
    } else {
      let initPeople = init[props.appId]
      const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
      if (leadManagePeople) {
        const leadManagePeopleObj = JSON.parse(leadManagePeople)
        const userConductor = leadManagePeopleObj[loginUser.work_code]
        if (userConductor && userConductor[props.appId]) {
          initPeople = userConductor[props.appId]
        }
      }
      // 设置初始值
      if (initPeople.conductor && initPeople.conductor) {
        form.value = {
          ...form.value,
          conductor: initPeople.conductor
        }
      }
      if (initPeople.follower) {
        form.value = {
          ...form.value,
          follower: initPeople.follower
        }
      }
      if (initPeople.customerRegion) {
        form.value = {
          ...form.value,
          customerRegion: initPeople.customerRegion
        }
      }
    }
  } catch (error) {
    console.log('getData error: ', error)
  }
}

const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 谷仓市场线索投放不过滤线索类型
  if (props.appId !== 'cos_fbu') {
    const errorData = props.data.find((item) => item.clueType !== 2)
    if (errorData) {
      DcMessage.error('请选择有效线索进行投放！')
      return
    }
  }
  visible.value = true
  form.value = {
    receiver: props.appId,
    subdomain: props.appId,
    clueIdList: props.data.map((item) => item.clueId)
  }
  initPeopleMessage()
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    savePeopleMessage()
    cluePush(form.value)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('投放处理中，结果稍后通过飞书消息提醒')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'LaunchButton' }
</script>
<style lang="scss" scoped>
.cluePush {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
.launchTable {
  :deep(.ant-table .ant-form-item.ant-form-item-has-error) {
    margin-bottom: 0;
  }
  :deep(.ant-form-item-explain-error) {
    display: none;
  }
}
</style>
